import styled from 'styled-components'

import { useOngoingEventInfo } from '~/features/common/queries/common'
import LoadingScreen from '~/shared/components/loading/LoadingScreen'
import Tag from '~/shared/components/tags/Tag'
import theme from '~/shared/styles/theme'

function EventInfo() {
  const { data, isLoading } = useOngoingEventInfo()

  if (isLoading) return <LoadingScreen />

  const { show_date, place } = data!

  return (
    <Wrapper>
      <SubTitle>행사 정보</SubTitle>
      <TagBox>
        <Tag $size={'sm'} $variant={'gray'}>
          개최일
        </Tag>
        <TagText>{show_date}</TagText>
      </TagBox>
      <TagBox>
        <Tag $size={'sm'} $variant={'gray'}>
          개최 장소
        </Tag>
        <TagText>{place}</TagText>
      </TagBox>
    </Wrapper>
  )
}

export default EventInfo

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: flex-start;

  box-sizing: border-box;
  width: 100%;
  height: auto;
  padding: 36px 24px;

  background-color: ${theme.colors.white};
  border: 1px solid ${theme.colors.grey_3};
  border-radius: 12px;

  @media ${theme.device.medium} {
    padding: 24px 20px;
  }
`

const SubTitle = styled.h2`
  ${theme.fontStyle.subTitle};
  text-align: left;
  white-space: pre-line;

  @media ${theme.device.medium} {
    ${theme.fontStyle.subTitleMobile};
    width: 100%;
    height: auto;
  }
`

const TagBox = styled.div`
  display: flex;
  gap: 36px;
  align-items: center;

  @media ${theme.device.medium} {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }
`

const TagText = styled.span`
  ${theme.fontStyle.text};
  color: #313634;
  word-wrap: break-word;

  @media ${theme.device.medium} {
    ${theme.fontStyle.textMobile};
  }
`
